module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('AppBlockWrapper', [_c('BreadcrumbsLayout', {
    attrs: {
      "breadcrumbs": _vm.crumbs
    }
  }, [(_vm.nothingFound) ? _c('PageError') : _c('AppCardTotalLayout', {
    attrs: {
      "sidebarPosition": "right"
    }
  }, [_c('ButtonCanRequest', {
    attrs: {
      "slot": "button",
      "possibleText": "Откликнуться",
      "isPossible": _vm.isActive,
      "factor": _vm.getFactor,
      "impossibleText": _vm.getImpossibleText
    },
    on: {
      "click": _vm.onRespond
    },
    slot: "button"
  }), _c('AppHeading', {
    attrs: {
      "slot": "heading"
    },
    slot: "heading"
  }, [_vm._v(_vm._s(_vm.name))]), _c('AppHeading', {
    attrs: {
      "slot": "heading",
      "level": "3",
      "mod": "bold"
    },
    slot: "heading"
  }, [_vm._v("Зарплата: " + _vm._s(_vm.salary))]), _c('template', {
    slot: "sidebar"
  }, [(_vm.sidebar && _vm.sidebar.partnerLogo) ? _c('AppPicture', {
    attrs: {
      "image": _vm.sidebar.partnerLogo,
      "alt": _vm.sidebar.partnerName
    }
  }) : _vm._e(), (_vm.sidebar && _vm.sidebar.partnerName) ? _c('div', [_c('AppHeading', {
    attrs: {
      "level": "4",
      "mod": "bold"
    }
  }, [_vm._v("Название организации:")]), _c('AppRouterLink', {
    attrs: {
      "mod": "small",
      "to": _vm.getRouterData
    }
  }, [_vm._v(_vm._s(_vm.sidebar.partnerName))])], 1) : _vm._e(), (_vm.sidebar && _vm.sidebar.description) ? _c('AppHeadingTextBlock', {
    attrs: {
      "name": "Описание деятельности организации:",
      "value": _vm.sidebar.description
    }
  }) : _vm._e(), (_vm.sidebar && _vm.sidebar.cop_multi_name) ? _c('AppHeadingTextBlock', {
    attrs: {
      "name": "Партнер ЦОПП:",
      "value": _vm.sidebar.cop_multi_name
    }
  }) : _vm._e(), (_vm.sidebar && _vm.sidebar.site) ? _c('AppHeadingTextBlock', {
    attrs: {
      "name": "Сайт:",
      "value": _vm.sidebar.site
    }
  }) : _vm._e(), (_vm.sidebar && _vm.sidebar.contactPerson) ? _c('AppHeadingTextBlock', {
    attrs: {
      "name": "Контактное лицо:",
      "value": _vm.sidebar.contactPerson
    }
  }) : _vm._e(), (_vm.sidebar && _vm.sidebar.email) ? _c('AppHeadingTextBlock', {
    attrs: {
      "name": "Электронная почта:",
      "value": _vm.sidebar.email
    }
  }) : _vm._e(), (_vm.sidebar && _vm.sidebar.phoneNumber) ? _c('AppWrapper', [_c('AppHeading', {
    attrs: {
      "level": "4",
      "mod": "bold"
    }
  }, [_vm._v("Телефон:")]), _c('AppHtmlRender', {
    attrs: {
      "mod": "list-zero-margin",
      "htmlString": _vm.sidebar.phoneNumber
    }
  })], 1) : _vm._e(), (_vm.sidebar && _vm.sidebar.organizationAddress) ? _c('AppHeadingTextBlock', {
    attrs: {
      "name": "Адрес организации:",
      "value": _vm.sidebar.organizationAddress
    }
  }) : _vm._e()], 1), _c('template', {
    slot: "main"
  }, [(_vm.main && _vm.main.description) ? _c('AppHtmlRender', {
    attrs: {
      "htmlString": _vm.main.description
    }
  }) : _vm._e(), _c('AppHeading', {
    attrs: {
      "level": "3",
      "mod": "bold, uppercase, bottom"
    }
  }, [_vm._v("Подробности вакансии")]), _c('AppCardOneGridLayout', [(_vm.main && _vm.main.duties) ? _c('AppWrapper', [_c('AppHeading', {
    attrs: {
      "level": "4",
      "mod": "bold"
    }
  }, [_vm._v("Обязанности:")]), _c('AppHtmlRender', {
    attrs: {
      "mod": "list-zero-margin",
      "htmlString": _vm.main.duties
    }
  })], 1) : _vm._e(), (_vm.main && _vm.main.employmentTypeName) ? _c('AppHeadingTextBlock', {
    attrs: {
      "name": "Тип занятости:",
      "value": _vm.main.employmentTypeName
    }
  }) : _vm._e(), (_vm.main && _vm.main.beginWork && _vm.main.endWork) ? _c('AppWrapper', [_c('AppHeading', {
    attrs: {
      "level": "4",
      "mod": "bold"
    }
  }, [_vm._v("График работы:")]), _c('AppText', [_vm._v("С " + _vm._s(_vm.main.beginWork) + " до " + _vm._s(_vm.main.endWork))])], 1) : _vm._e(), (_vm.main && _vm.main.placeTypeName) ? _c('AppHeadingTextBlock', {
    attrs: {
      "name": "Место работы:",
      "value": _vm.main.placeTypeName
    }
  }) : _vm._e(), (_vm.main && _vm.main.workPlaceAddress) ? _c('AppHeadingTextBlock', {
    attrs: {
      "name": "Адрес места работы:",
      "value": _vm.main.workPlaceAddress
    }
  }) : _vm._e(), (_vm.main && _vm.main.isAgreement) ? _c('AppHeadingTextBlock', {
    attrs: {
      "name": "Оплата по договоренности:",
      "value": _vm.main.isAgreement
    }
  }) : _vm._e(), (_vm.main && _vm.main.isOtherCities) ? _c('AppHeadingTextBlock', {
    attrs: {
      "name": "Рассматриваем кандидатов из других городов:",
      "value": _vm.main.isOtherCities
    }
  }) : _vm._e(), (_vm.main && _vm.main.competencesName) ? _c('AppHeadingTextBlock', {
    attrs: {
      "name": "Компетенции:",
      "value": _vm.main.competencesName
    }
  }) : _vm._e(), (_vm.main && _vm.main.professionsName) ? _c('AppHeadingTextBlock', {
    attrs: {
      "name": "Профессии:",
      "value": _vm.main.professionsName
    }
  }) : _vm._e(), (_vm.main && _vm.main.requirements) ? _c('AppWrapper', [_c('AppHeading', {
    attrs: {
      "level": "3",
      "mod": "bold, uppercase, bottom"
    }
  }, [_vm._v("Требования к кандидату")]), _c('AppHtmlRender', {
    attrs: {
      "mod": "list-zero-margin",
      "htmlString": _vm.main.requirements
    }
  })], 1) : _vm._e(), (_vm.main && _vm.main.experience) ? _c('AppWrapper', [_c('AppHeading', {
    attrs: {
      "level": "4",
      "mod": "bold, uppercase, bottom"
    }
  }, [_vm._v("Опыт работы:")]), _c('AppHtmlRender', {
    attrs: {
      "mod": "list-zero-margin",
      "htmlString": _vm.main.experience
    }
  })], 1) : _vm._e(), (_vm.main && _vm.main.educationLevelName) ? _c('AppHeadingTextBlock', {
    attrs: {
      "name": "Уровень образования:",
      "value": _vm.main.educationLevelName
    }
  }) : _vm._e(), (_vm.main && _vm.main.driverLicenseName) ? _c('AppHeadingTextBlock', {
    attrs: {
      "name": "Водительские права:",
      "value": _vm.main.driverLicenseName
    }
  }) : _vm._e(), (_vm.main && _vm.main.languages) ? _c('AppHeadingTextBlock', {
    attrs: {
      "name": "Иностранные языки:",
      "value": _vm.main.languages
    }
  }) : _vm._e(), (_vm.main && _vm.main.publish_date) ? _c('AppHeadingTextBlock', {
    attrs: {
      "name": "Дата публикации вакансии:",
      "value": _vm.main.publish_date
    }
  }) : _vm._e(), (_vm.imgs.length) ? _c('AppWrapper', [_c('AppHeading', {
    attrs: {
      "level": "4",
      "mod": "bold, uppercase, bottom"
    }
  }, [_vm._v("Фотогалерея:")]), _c('Slider', {
    attrs: {
      "imgs": _vm.imgs
    }
  })], 1) : _vm._e(), (_vm.main && _vm.main.video) ? _c('AppWrapper', [_c('AppHeading', {
    attrs: {
      "level": "4",
      "mod": "bold, uppercase, bottom"
    }
  }, [_vm._v("Видео:")]), _c('AppHtmlRender', {
    attrs: {
      "mod": "list-zero-margin",
      "htmlString": _vm.main.video
    }
  })], 1) : _vm._e(), _c('ButtonCanRequest', {
    attrs: {
      "possibleText": "Откликнуться",
      "isPossible": _vm.isActive,
      "impossibleText": _vm.getImpossibleText
    },
    on: {
      "click": _vm.onRespond
    }
  })], 1)], 1)], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d3fb3d2","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/vacancies/card/VacanciesCard.vue
// module id = 9aa17a6a56a78504974c
// module chunks = 15